import React, { useEffect, useState } from "react";
// import { list, add, edit, detail } from "../../services/schedule.services";
import * as DoctorService from "../../../admin/services/doctor.services";
import { LOADER_TIMEOUT_TIME, ROLE, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { formateDate, getUser, handleOffcanvasScroll, handleServerValidations, TrimText } from "../../../../utils/commonfunction";
import CustomError from "../../../../utils/customError";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import RecordNotFound from "../../shared/recordNotFound";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";
import { useValidationSchemas } from "../../validator/validation";

export default function Schedule() {
    const navigate = useNavigate()
    const location = useLocation();
    const params = useParams();
    const { t } = useTranslation();
    const [List, setList] = useState([]);
    const { scheduleValidationSchema, editScheduleValidationSchema } = useValidationSchemas();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(true);
    const [scheduleDetail, setScheduleDetail] = useState({});
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [sortConfig, setSortConfig] = useState({ column: 'createdAt', order: SORT_D });
    const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: 'date', order: SORT_D });
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
    const [searchParams] = useSearchParams();
    const doctorDataNew = searchParams?.get("doctor_id");


    const handleSort = (key) => {
        let direction = SORT_A;
        if (sortConfig.column === key && sortConfig.order === SORT_A) {
            direction = SORT_D;
        }
        setSortConfig({ column: key, order: direction });
    };

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1;
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }
        formData.append("doctor_id", doctorDataNew);
        DoctorService.listSchedule(formData, ROLE.CENTER)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    navigate(`/center/settings/doctor/schedule/${data.data.page}?doctor_id=${doctorDataNew}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig]);


    const getScheduleDetail = (item) => {
        const formData = new FormData()
        formData.append("doctor_id", doctorDataNew)
        formData.append("time_slot_id", item?._id)
        DoctorService.detailSchedule(formData, ROLE.CENTER)
            .then((response) => {
                editForm.setValues({
                    o_id: response?.data?._id || "",
                    available_date: response?.data?.date || "",
                    available_start_time: response?.data?.from || "",
                    available_end_time: response?.data?.to || "",
                });
                setScheduleDetail(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const addForm = useFormik({
        initialValues: {
            available_date: "",
            available_start_time: "",
            available_end_time: "",
        },
        validationSchema: scheduleValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("doctor_id", doctorDataNew);
            const scheduleData = {
                date: values.available_date,
                from: values.available_start_time,
                to: values.available_end_time
            };
            formData.append("schedule", JSON.stringify(scheduleData));
            setAddSubmissionLoader(true);
            DoctorService.addSchedule(formData, ROLE.CENTER)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeader(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    const editForm = useFormik({
        initialValues: {
            o_id: "",
            available_date: "",
            available_start_time: "",
            available_end_time: "",
        },
        validationSchema: editScheduleValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setEditSubmissionLoader(true);
            const formData = new FormData();
            formData.append("o_id", scheduleDetail._id);
            formData.append("doctor_id", doctorDataNew);
            formData.append("time_slot_id", scheduleDetail._id);
            const scheduleData = {
                date: values.available_date,
                from: values.available_start_time,
                to: values.available_end_time
            };
            formData.append("schedule", JSON.stringify(scheduleData));
            DoctorService.editSchedule(formData,ROLE.CENTER)
                .then((response) => {
                    setEditSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeaderEdit(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setEditSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    const getDateWithTime = (timeValue) => {
        if (!timeValue) return null;
        const [hours, minutes, seconds] = timeValue.split(':');
        const date = new Date();
        date.setHours(hours, minutes, seconds || '00');
        return date;
    };

    const handleStartTimeChange = (e) => {
        addForm.setFieldTouched('available_start_time', true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(':');
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || '00';
            addForm.setFieldValue('available_start_time', `${hours}:${minutes}:${seconds}`);
        }
    };

    const handleEndTimeChange = (e) => {
        addForm.setFieldTouched('available_end_time', true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(':');
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || '00';
            addForm.setFieldValue('available_end_time', `${hours}:${minutes}:${seconds}`);
        }
    };

    return (
        <main id="main-content">
            <div className="inner-container">
                <div className="page-header d-flex align-items-center">
                    {/* <h4 className="heading-title-text">{t("Schedule Management")}</h4> */}
                </div>
                <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
                    <div className="search-box">
                        {/* <input
                            type="text"
                            value={searchValue}
                            className="form-control search-input"
                            placeholder={t("center.staff.input_placeholder_search")}
                            onChange={handleSearchChange}
                        /> */}
                    </div>
                    <div className="card-head-group d-flex align-items-center gap-2">
                        <div className="tabls-dowpdown">
                            {/* <select
                                className="form-control cp"
                                value={selectedStatus}
                                onChange={handleSelectChange}
                            >
                                <option disabled="" value="">
                                    {t("center.staff.label_select_status")}
                                </option>
                                <option value="1"> {t("center.staff.btn_active")}</option>
                                <option value="0">{t("center.staff.btn_inactive")}</option>
                            </select> */}
                        </div>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                setOpenWithHeader(true);
                            }}
                        >
                            {t("Add New Schedule")}
                        </button>
                    </div>
                </div>

                <div className="dashboard-content-wraper">
                    <div className="category-list-wrap">
                            <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>S. No.</th>
                                                    <th>{t("Date")}
                                                        {/* <span style={{ cursor: 'pointer' }}
                                                            onClick={() => handleSort('date')}
                                                        >

                                                            <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'date' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '5px' }}></i>
                                                            <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'date' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '-8px' }} />
                                                        </span> */}
                                                    </th>
                                                    <th>{t("Start Time")}
                                                        {/* <span style={{ cursor: 'pointer' }}
                                                            onClick={() => handleSort('from')}
                                                        >

                                                            <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'from' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '5px' }}></i>
                                                            <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'from' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '-8px' }} />
                                                        </span> */}
                                                    </th>
                                                    <th>{t("End Time")}
                                                        {/* <span style={{ cursor: 'pointer' }}
                                                            onClick={() => handleSort('to')}
                                                        >

                                                            <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'to' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '5px' }}></i>
                                                            <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'to' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '-8px' }} />
                                                        </span> */}
                                                    </th>
                                                    <th style={{ width: "150px" }}>{t("center.staff.label_action")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loader ? (
                                                    <td colSpan="5">
                                                        <Skeleton className="mb-2" height={50} count={5} />
                                                    </td>
                                                ) : List?.length ? (
                                                    List.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{offset + index + 1}</td>
                                                                <td>{formateDate(item?.date)}</td>
                                                            <td>{item?.from}</td>
                                                            <td>{item?.to}</td>
                                                            <td className="d-flex">
                                                                <div className="dropdown ms-2">
                                                                    <button className="btn btn-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <i className="ti ti-dots-vertical"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                        {/* <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    getStaffDetail(item);
                                                                                }}
                                                                                data-bs-toggle="offcanvas"
                                                                                data-bs-target="#view-staff"
                                                                            >
                                                                                <i className="ti ti-eye"></i>
                                                                                {t("center.button.btn_view")}
                                                                            </a>
                                                                        </li> */}
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    getScheduleDetail(item);
                                                                                    setOpenWithHeaderEdit(true);
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-edit"></i>
                                                                                {t("center.button.btn_edit")}
                                                                            </a>
                                                                        </li>
                                                                        {/* <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    deleteRecord(item);
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-trash"></i>
                                                                                {t("center.button.btn_delete")}
                                                                            </a>
                                                                        </li> */}
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })) : (
                                                    <td colSpan="5">
                                                        <RecordNotFound heading="center.staff.no_staff_found" />
                                                    </td>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="table-status-info d-flex justify-content-between align-items-center">
                                        <span>{t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}</span>
                                        <nav aria-label="Page navigation example" title={page}>
                                            {totalRecords && totalRecords > 0 ?
                                                <CustomPagination
                                                    datalength={totalRecords}
                                                    itemperpage={itemPerPage}
                                                    currentPage={page}
                                                    custompath="page"
                                                    setPage={setPage}
                                                    pageRoute={[{ name: "settings", path: "/center/settings/doctor/schedule" }]} /> : ""
                                            }
                                        </nav>
                                    </div>
                                    {/* <div className="table-status-info">
                                        <div className="mb-2 text-left">
                                            <button className="btn btn-primary" type="button" onClick={() => {
                                                navigate(`/center/settings/doctor/list`)
                                            }}>Back</button>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>
                                                {t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}
                                            </span>
                                            <nav aria-label="Page navigation example" title={page}>
                                                {totalRecords && totalRecords > 0 ? (
                                                    <CustomPagination
                                                        datalength={totalRecords}
                                                        itemperpage={itemPerPage}
                                                        currentPage={page}
                                                        custompath="page"
                                                        setPage={setPage}
                                                        pageRoute={[{ name: "settings", path: "/center/settings/doctor/schedule" }]}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </nav>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                    </div>
                </div>
                <div>
                </div>
            </div>

            {/* add item modal  */}
            <Drawer open={openWithHeader}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Create Schedule")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeader(false);
                                addForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editNewEmail", "rsuite");
                    }}
                >
                    <form onSubmit={addForm.handleSubmit}>
                        <CustomError name="profile_image" form={addForm} className="text-danger text-center my-3" />
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Choose Date")}
                                <span>*</span>
                            </label>
                            <DatePicker oneTap={true} classPrefix="restaurant" placeholder={t("Choose Date")} placement="autoVertical" format="dd.MM.yyyy" cleanable={false} editable={false} name="available_date" onChange={(e) => {
                                addForm.setFieldTouched('available_date', true);
                                addForm.setFieldValue("available_date", e);
                            }} value={new Date(addForm.values.available_date)}
                                onBlur={addForm.handleBlur}
                                shouldDisableDate={(date) => {
                                    const currentDate = new Date();
                                    currentDate.setHours(0, 0, 0, 0);
                                    return date < currentDate;
                                }}
                            />
                            <CustomError name="available_date" form={addForm} className="text-danger" />
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="available_start_time"
                                            onChange={handleStartTimeChange}
                                            value={getDateWithTime(addForm.values.available_start_time)}
                                            onBlur={addForm.handleBlur}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="available_start_time" form={addForm} className="text-danger" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        End Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="available_end_time"
                                            onChange={handleEndTimeChange}
                                            value={getDateWithTime(addForm.values.available_end_time)}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="available_end_time" form={addForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                                Create
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>


            <Drawer open={openWithHeaderEdit}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Edit Schedule")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeaderEdit(false);
                                editForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editEmail", "rsuite");
                    }}
                >
                    <form onSubmit={editForm.handleSubmit}>
                        <CustomError name="profile_image" form={editForm} className="text-danger text-center my-3" />
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Choose Date")}
                                <span>*</span>
                            </label>
                            <DatePicker oneTap={true} classPrefix="restaurant" placeholder={t("Choose Date")} placement="autoVertical" format="dd.MM.yyyy" cleanable={false} editable={false} name="available_date" onChange={(e) => {
                                editForm.setFieldTouched('available_date', true);
                                editForm.setFieldValue("available_date", e);
                            }} value={new Date(editForm.values.available_date)}
                                onBlur={editForm.handleBlur}
                                shouldDisableDate={(date) => {
                                    const currentDate = new Date();
                                    currentDate.setHours(0, 0, 0, 0);
                                    return date < currentDate;
                                }} 

                            />
                            <CustomError name="available_date" form={editForm} className="text-danger" />
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                            <div className="col-md-12">
                            </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time
                                        <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker classPrefix="restaurant" placement="autoVertical" format="HH:mm" cleanable={false} editable={true} name="openingTime" onChange={(e) => {
                                            editForm.setFieldTouched('available_start_time', true);
                                            const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                            if (match) {
                                                const [hours, minutes] = match[0].split(':');
                                                editForm.setFieldValue("available_start_time", `${hours}:${minutes}:00`);
                                            }
                                        }} value={getDateWithTime(editForm.values.available_start_time)}
                                            onBlur={editForm.handleBlur} 
                                             hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="available_start_time" form={editForm} className="text-danger" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        End Time
                                        <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker classPrefix="restaurant" placement="autoVertical" format="HH:mm" cleanable={false} editable={true} name="closingTime" onChange={(e) => {
                                                editForm.setFieldTouched('available_end_time', true);
                                                const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                                if (match) {
                                                    const [hours, minutes] = match[0].split(':');
                                                    editForm.setFieldValue("available_end_time", `${hours}:${minutes}:00`);
                                                }
                                            }} 
                                            value={getDateWithTime(editForm.values.available_end_time)}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="available_end_time" form={editForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                                Update
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            {/* <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Doctor
                    </h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="view-staff-info">
                        <div className="row gap-4">
                            {staffDetail?.profile_image ?
                                <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                                    <div className="avatar avatar-xl">
                                        <img alt="profile_image" src={staffDetail?.profile_image ? staffDetail?.profile_image : DefaultProfileImg} />
                                    </div>
                                </div> : null}
                            <div className="col-md-12">
                                <h4>{t("Doctor ID")}</h4>
                                <p>{staffDetail?.doctor_register_id}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Doctor Name")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail?.name)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Email")}</h4>
                                <p>{staffDetail?.email}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Contact Number")}</h4>
                                <p>{staffDetail?.phone_number}</p>
                            </div>
                            <div className='col-md-12'>
                                <h4>{t("DOB")}</h4>
                                <p>{formatePickerDate(staffDetail.dob)} </p>
                            </div>
                            <div className='col-md-12'>
                                <h4>{t("Gender")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail.gender)} </p>
                            </div>
                            <div className='col-md-12'>
                                <h4>{t("Specialization")}</h4>
                                <p>{capitalizeFirstLetter(staffDetail.specialisation)} </p>
                            </div>
                            <div className='col-md-12'>
                                <h4>{t("Start Time")}</h4>
                                <p>{(staffDetail.start_available_time)} </p>
                            </div>
                            <div className='col-md-12'>
                                <h4>{t("End Time")}</h4>
                                <p>{(staffDetail.end_available_time)} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </main>
    );
}
